import { createReducer, on } from '@ngrx/store';

import { ViewportActions } from './viewport.actions';
import { initialViewportState, PageOrientation, ViewportState } from './viewport.model';

export const viewportStateReducer = createReducer<ViewportState>(
  initialViewportState,

  on(ViewportActions.breakpointSet, (state, { breakpointState, currentScreenSize }): ViewportState => ({
    ...state,
    ...breakpointState,
    currentScreenSize,
  })),
  on(ViewportActions.resizeSet, (state, { pageHeight, pageWidth }): ViewportState => ({
    ...state,
    pageHeight,
    pageWidth,
    orientation: pageHeight < pageWidth ? PageOrientation.landscape : PageOrientation.portrait,
  })),
  on(ViewportActions.keyboardVisibilityChanged, (state, { keyboardVisible }): ViewportState => ({
    ...state,
    keyboardVisible,
  }))
);
